export const APP_SWITCH_ANALYTICS_EVENTS = {
  openAppControlPanel: '_open_app_control_panel',
  openAppVms: '_open_app_vms',
} as const;

export type AppSwitchAnalyticsEvent =
  (typeof APP_SWITCH_ANALYTICS_EVENTS)[keyof typeof APP_SWITCH_ANALYTICS_EVENTS];

export function resolveAppSwitchAnalyticsEvent(
  selectedOrigin: string,
  controlPanelOrigin: string,
  vmsOrigin: string,
): AppSwitchAnalyticsEvent | undefined {
  if (selectedOrigin === controlPanelOrigin) {
    return APP_SWITCH_ANALYTICS_EVENTS.openAppControlPanel;
  }
  if (selectedOrigin === vmsOrigin) {
    return APP_SWITCH_ANALYTICS_EVENTS.openAppVms;
  }
  return undefined;
}
